/**
 * Offer enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Offer state — lifecycle of an offer record
export const offerStateLabels = {
    draft: 'Draft',
    active: 'Active',
    paused: 'Paused',
    expired: 'Expired',
};
export const offerStateValues = Object.keys(offerStateLabels);
// Offer discount type — discriminator for the discount-shape fields on offer.
// Percentage, fixed amount and same-treatment bundles are selectable.
// Fixed price remains available when editing existing offers of that type.
export const offerDiscountTypeLabels = {
    percentage: 'Percentage Discount',
    fixed_amount: 'Fixed Amount Discount',
    fixed_price: 'Fixed price',
    buy_x_get_y: 'Buy X, Get Y',
};
export const offerDiscountTypeValues = Object.keys(offerDiscountTypeLabels);
//# sourceMappingURL=offers.js.map